  import React, {useState, useEffect, useContext, useCallback, Fragment} from "react";
  import Row from "@amzn/meridian/row";
  import RadioButton from "@amzn/meridian/radio-button";
  import Tag from "@amzn/meridian/tag";
  import Column from "@amzn/meridian/column";
  import ControlGroup from "@amzn/meridian/control-group";
  import Checkbox from "@amzn/meridian/checkbox";
  import {FiltersDataContext} from "./context/FiltersDataContext";
  import {FiltersStateContext} from "./context/FiltersStateContext";
  import {FiltersStateInitializer} from "./defaultInitializer/FiltersStateInitializer";
  import DatePicker from "@amzn/meridian/date-picker";
  import Text from "@amzn/meridian/text";
  import Box from "@amzn/meridian/box"
  import Link from "@amzn/meridian/link"
  import {VIEW_TO_FILTERS_MAP, getDirectionInTier2, VIEW_TO_STATIC_FILTERS_MAP} from "./dataStore/FilterDataStore";
  import Select, { SelectOption } from "@amzn/meridian/select";
  import Button from "@amzn/meridian/button";
  import Icon from "@amzn/meridian/icon";
  import filterTokens from "@amzn/meridian-tokens/base/icon/filter";
  import {getCycleDataFromParent, getFeaturesFromParent} from "../handler/ParentDataHandler";
  import {FormattedMessage , injectIntl} from "react-intl";
  import Input from "@amzn/meridian/input";
  import Alert from "@amzn/meridian/alert";
  import Toaster from "@amzn/meridian/toaster";
  import {
    getLocalTimeDeliveryWindowFromUtcDeliveryWindow,
      isFilterConfigured,
    isINRegion
} from "../util/CommonUtils";
  import {ACTION_TYPE, FEATURES, FILTER_DEFAULT, WASTE_TRANSFER_NOTE} from "./constants/CommonConstants";
  import {chainWalk} from "./CommonUtils";
  import {FeatureConfigContext} from "./context/FeatureConfigContext";
  import {useDeviceLayout} from "./context/DeviceLayoutContext";
  import {MobileDisplay} from "./MobileDisplay";
  import {
    FILTER_ACTIONS,
    FILTER_KEYS,
    FILTER_VALUES,
    TAG_LABELS,
    FORMATTED_MESSAGE_IDS,
    TOASTER_MESSAGES,
    MISC_CONSTANTS
  } from "./constants/FilterConstants";

  export const FilterExpander = ({children, onToggle}) => {
      const [open, setOpen] = useState(false)
      const onClick = useCallback(() => {
          setOpen(!open)
          onToggle && onToggle(!open)
      }, [open, onToggle])

      const FilterButton = () => (
          <Button onClick={onClick} type="link" size="medium" >
              <Icon tokens={filterTokens} /> Filters
          </Button>
      )
      return (
          <React.Fragment>
              <FilterButton />
              {open ? children : null}
          </React.Fragment>


      )
  }


  //TODO : Dwell start < end time & separate out the tag and filters data
  const CommonFilters = (props) => {

      //No dispatch is required in case of filter data as filter caller will be the only component that will
      //be responsible for calling the services  for fetching filter values
      const { filtersData , dispatchData} = useContext(FiltersDataContext)
      const { selectedFilterValues, dispatch } = useContext(FiltersStateContext)
      const {configViewModel, configDispatch} = useContext(FeatureConfigContext)
      const {isMobile, spacingInset_shorthand4} = useDeviceLayout();
      const [isFilterExpanded, setIsFilterExpanded] = useState(false);

      var context = FiltersStateInitializer (selectedFilterValues, [])
      const formattedIdPrefix = FORMATTED_MESSAGE_IDS.FILTERS_PREFIX;
      var spaceString = MISC_CONSTANTS.SPACE_STRING;
      const [toasters, setToasters] = useState([]);

      //Extracting values from filter context
      var cycleValues = filtersData.cycles;
      var CPTValues = filtersData.CPT;
      var packageStatusValues = filtersData.packageStatuses;

      let today = new Date().toISOString().substr(0, 10);

      const enableToaster = () => {
          if (Number(context.dwellEnd) >= Number(context.dwellStart)) {
              setToasters([{ id: TOASTER_MESSAGES.DWELL_TIME_ERROR, timeout: 3000}])
          }
      }

      //props or url path to be changed only when apply filter

      useEffect(() => {
          getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED, FEATURES.IS_EWASTE_WTN_ENABLED]).then(featureStatus => {
              configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
          })
          if (props.view === "PACKAGE_DRILLDOWN" && selectedFilterValues.isApplyFilterClicked === true)
              constructState(selectedFilterValues, context);
      }, [selectedFilterValues]);

      const isCPTFilterEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false);
      const isEWasteWtnEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_EWASTE_WTN_ENABLED], false);

      const getCycleData = () => {
          if(cycleValues.length===0) {

              getCycleDataFromParent().then(cycleData => {
                  dispatchData({ type: FILTER_ACTIONS.INITIALIZE_CYCLES, cycleData});
              })
          }

      }

      const getCPTData = () => {
          if(CPTValues.length === 0) {
              dispatchData({type: FILTER_ACTIONS.FETCH_CPT, data:{dispatcher: dispatchData}});
          }
      }

      function isFilterSet() {
          let isFilterSet = false
          Object.keys(context).filter(key => !VIEW_TO_STATIC_FILTERS_MAP[props.view].includes(key))
              .filter(key => isFilterConfigured(key, context))
              .forEach(key => {
                  if (Array.isArray(FILTER_DEFAULT[key]))
                      isFilterSet = isFilterSet || context[key].length > 0
                  else
                      isFilterSet = isFilterSet ||  (context[key] !== FILTER_DEFAULT[key])
              })
          return isFilterSet
      }

      function renderLegRadioButtons() {
          return (
              <Fragment>
                <RadioButton
                    size="medium"
                    checked={context.leg === FILTER_VALUES.FORWARD}
                    onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.LEG, value : data })}
                    name={FILTER_KEYS.LEG}
                    value={FILTER_VALUES.FORWARD}>
                    <FormattedMessage id={formattedIdPrefix.concat(FORMATTED_MESSAGE_IDS.FORWARD)} defaultMessage={FILTER_VALUES.FORWARD}/>
                </RadioButton>
                <RadioButton
                    size="medium"
                    checked={context.leg === FILTER_VALUES.REVERSE}
                    onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.LEG, value : data })}
                    name={FILTER_KEYS.LEG}
                    value={FILTER_VALUES.REVERSE}>
                    <FormattedMessage id={formattedIdPrefix.concat(FORMATTED_MESSAGE_IDS.REVERSE)} defaultMessage={FILTER_VALUES.REVERSE}/>
                </RadioButton>
              </Fragment>
          )
      }

      function renderEstimatedArrivalDatePickers() {
          return (
              // display:contents keeps this test hook layout-neutral — the two DatePickers
              // remain direct flex children of the parent Row/Column (as they were with the
              // original <Fragment>), so wrapping for the data-test attr doesn't alter spacing.
              <div data-test="date-filter-display" style={{display: "contents"}}>
                  <DatePicker
                      onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.START_PDD , value : data })}
                      value={context.startPDD}
                      size="small"
                      disabledDates={ value => {
                          if (context.endPDD !== '' & value > context.endPDD)
                              return true;
                          return false;
                      }}/>
                  <DatePicker
                      onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.END_PDD, value : data })}
                      value={context.endPDD !== undefined? context.endPDD : context.startPDD}
                      size="small"
                      disabledDates={ value => {
                          if (value < context.startPDD)
                              return true;
                          return false;
                      }}/>
              </div>
          );
      }


      function renderLastUpdatedDatePickers() {
          return (
              <Fragment>
                  <DatePicker
                      onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.LAST_UPDATED_START , value : data })}
                      value={context.lastUpdatedStart}
                      size="small"
                      disabledDates={ value => {
                          if (context.lastUpdatedEnd !== '' & value > context.lastUpdatedEnd)
                              return true;
                          return false;
                      }}/>

                  <DatePicker
                      onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.LAST_UPDATED_END , value : data })}
                      value={context.lastUpdatedEnd}
                      size="small"
                      disabledDates={ value => {
                          if (value < context.lastUpdatedStart)
                              return true;
                          return false;
                      }}/>
              </Fragment>
          )
      }

      function renderShipDatePickers() {
          return (
              <Fragment>
                  <DatePicker
                      onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.SHIP_DATE_START , value : data })}
                      value={context.shipDateStart}
                      size="small"
                      disabledDates={ value => {
                          if (context.shipDateEnd !== '' && value > context.shipDateEnd)
                              return true;
                          return false;
                      }}/>
                  <DatePicker
                      onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.SHIP_DATE_END, value : data })}
                      value={context.shipDateEnd !== undefined? context.shipDateEnd : context.shipDateStart}
                      size="small"
                      disabledDates={ value => {
                          if (value < context.shipDateStart)
                              return true;
                          return false;
                      }}/>
              </Fragment>
          )
      }

      function renderMinutesInStateInputs() {
          return (
              <Fragment>
                  <Row>
                      <Text type="b300"><FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.FROM_DWELL} defaultMessage="From"/></Text>
                      <Input value={context.dwellEnd}
                             onChange={(dwellEnd) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.DWELL_END, value : dwellEnd})}
                             pattern="[0-9]+"
                             width={90}
                             resize="none"
                             error= {context.dwellEnd !== '' && Number(context.dwellEnd) >= Number(context.dwellStart)
                                 ? true : false
                             }

                      />

                  </Row>
                  <Row>
                      <Text type="b300"><FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.TO_DWELL} defaultMessage="To"/>{spaceString} </Text>
                      <Input value={context.dwellStart}
                             onChange={(dwellStart) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.DWELL_START, value : dwellStart})}
                             pattern="[0-9]+"
                             width={90}
                             resize="none"
                      />
                  </Row>
              </Fragment>
          )
      }

      function renderLegFilterTag() {
          return VIEW_TO_FILTERS_MAP[props.view].includes("LEG") && context.leg ? (
              <Tag key={context.leg} type="theme">
                  <FormattedMessage 
                      id={formattedIdPrefix.concat(context.leg.toLocaleLowerCase().split(' ').join('_'))}
                      defaultMessage={context.leg}
                  />
              </Tag>
          ) : null;
      }

      function renderCycleFilterTags() {
          return !isCPTFilterEnabled ? context.cycles.map(cycle => (
              <Tag 
                  key={cycle}
                  onClose={() => dispatch({ type: FILTER_ACTIONS.REMOVE_FILTER_ARRAY, key: FILTER_KEYS.CYCLES, value: cycle })}
                  type="theme"
              >
                  <FormattedMessage id={formattedIdPrefix.concat(cycle.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={cycle}/>
              </Tag>
          )) : null;
      }

      function renderCPTFilterTags() {
          return isCPTFilterEnabled ? context.CPT.map(CPT => (
              <Tag 
                  key={CPT}
                  onClose={() => dispatch({ type: FILTER_ACTIONS.REMOVE_FILTER_ARRAY, key: FILTER_KEYS.CPT, value: CPT })}
                  type="theme"
              >
                  <FormattedMessage id={formattedIdPrefix.concat(CPT.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={CPT}/>
              </Tag>
          )) : null;
      }

      function shouldRenderFilter({ value, condition }) {
          return value && (!condition || (typeof condition === 'function' && condition()));
      }

      function renderDateFilterTags() {
          const dateFilters = [
              { key: FILTER_KEYS.START_PDD, value: context.startPDD, label: TAG_LABELS.EAD_FROM },
              { key: FILTER_KEYS.END_PDD, value: context.endPDD, label: TAG_LABELS.EAD_TO },
              { key: FILTER_KEYS.SHIP_DATE_START, value: context.shipDateStart, label: TAG_LABELS.SHIP_DATE_FROM },
              { key: FILTER_KEYS.SHIP_DATE_END, value: context.shipDateEnd, label: TAG_LABELS.SHIP_DATE_TO },
              { key: FILTER_KEYS.LAST_UPDATED_START, value: context.lastUpdatedStart, label: TAG_LABELS.LAST_UPDATED_FROM, condition: () => isFilterConfigured(FILTER_KEYS.LAST_UPDATED_START, context.page) },
              { key: FILTER_KEYS.LAST_UPDATED_END, value: context.lastUpdatedEnd, label: TAG_LABELS.LAST_UPDATED_TO, condition: () => isFilterConfigured(FILTER_KEYS.LAST_UPDATED_END, context.page) }
          ];

          return (
              <Fragment>
                  {dateFilters.map((filterData) => 
                      shouldRenderFilter(filterData) && (
                          <Tag key={`${filterData.key}-${filterData.value}`} onClose={() => dispatch({ type: FILTER_ACTIONS.REMOVE_FILTER, key: filterData.key, value: filterData.value })} type="theme">
                              {filterData.label}{filterData.value}
                          </Tag>
                      )
                  )}
              </Fragment>
          );
      }

      const formatMessageId = (text, prefix = formattedIdPrefix) => 
          prefix.concat(text.toLowerCase().split(' ').join('_'));

      const renderTag = (item, key, getValue = (x) => x, messagePrefix = formattedIdPrefix) => {
          const value = getValue(item);
          // Ensure value is a valid React key
          if (value == null) {
              console.warn('Invalid null or undefined value used as React key');
              return null;
          }
          return (
              <Tag 
                  key={value}
                  onClose={() => dispatch({ type: FILTER_ACTIONS.REMOVE_FILTER_ARRAY, key, value })}
                  type="theme"
              >
                  <FormattedMessage 
                      id={formatMessageId(value, messagePrefix)} 
                      defaultMessage={value}
                  />
              </Tag>
          );
      };

      function renderPackageFilterTags() {
          return (
              <Fragment>
                  {context.packageTypes.map(item => 
                      renderTag(item, FILTER_KEYS.PACKAGE_TYPES)
                  )}
                  {context.packageTypes_Reverse.map(item => 
                      renderTag(item, FILTER_KEYS.PACKAGE_TYPES_REVERSE)
                  )}
                  {context.packageStatuses.map(item => 
                      renderTag(item, FILTER_KEYS.PACKAGE_STATUSES, 
                          (pkg) => getDirectionInTier2(context.leg, pkg), 
                          FORMATTED_MESSAGE_IDS.COMMONS_PREFIX
                      )
                  )}
              </Fragment>
          );
      }

      function renderDeliveryFilterTags() {
          return (
              <Fragment>
                  {context.deliveryWindow.map(deliveryWindow => (
                      <Tag 
                          key={deliveryWindow}
                          onClose={() => dispatch({ type: FILTER_ACTIONS.REMOVE_FILTER_ARRAY, key: FILTER_KEYS.DELIVERY_WINDOW, value: deliveryWindow })}
                          type="theme"
                      >
                          <FormattedMessage id={FORMATTED_MESSAGE_IDS.COMMONS_PREFIX + FORMATTED_MESSAGE_IDS.SCHEDULED_DELIVERY_WINDOW} defaultMessage="Scheduled Delivery Window"/> : {getLocalTimeDeliveryWindowFromUtcDeliveryWindow(deliveryWindow, context.stationTimeZone)}
                      </Tag>
                  ))}
                  {context.sameDay && (
                      <Tag 
                          key={TAG_LABELS.SAME_DAY}
                          onClose={() => dispatch({ type: FILTER_ACTIONS.REMOVE_FILTER, key: FILTER_KEYS.SAME_DAY, value: false })}
                          type="theme"
                      >
                          <FormattedMessage id={formattedIdPrefix.concat(FORMATTED_MESSAGE_IDS.SAME_DAY)} defaultMessage="Same day"/>
                      </Tag>
                  )}
              </Fragment>
          );
      }

      function renderAppliedFilterTags() {
          return (
              <Row alignmentVertical="center" spacing="small" minWidth="auto">
                  {renderLegFilterTag()}
                  {renderCycleFilterTags()}
                  {renderCPTFilterTags()}
                  {renderDateFilterTags()}
                  {renderPackageFilterTags()}
                  {renderDeliveryFilterTags()}
                  {isFilterSet() ? (
                      <Link onClick={() => dispatch({ type: FILTER_ACTIONS.REMOVE_ALL_FILTERS, view: props.view, context: context.page})} type="secondary">
                          <span style={{whiteSpace: 'nowrap'}}>
                              <FormattedMessage id={"linehaul_filter." + FORMATTED_MESSAGE_IDS.CLEAR_ALL} defaultMessage="Clear all"/>
                          </span>
                      </Link>
                  ) : null}
              </Row>
          )
      }

      function renderFilterOptions() {
          return (
              <Fragment>
                  {VIEW_TO_FILTERS_MAP[props.view].includes("LEG") ?
                          <Column heights="fill" spacingInset="none medium none"><Text type="h100">
                              <FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.LEG} defaultMessage="Leg"/></Text>
                              {isMobile ? <Row>{renderLegRadioButtons()}</Row> : renderLegRadioButtons()}
                          </Column> : null}
              {!isCPTFilterEnabled && VIEW_TO_FILTERS_MAP[props.view].includes("CYCLE") ?
                  <Column heights="fill" spacingInset="none medium none">
                      <ControlGroup
                          label={props.intl.formatMessage({id: FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.CYCLE})}
                          name={FILTER_KEYS.CYCLES}
                          onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.CYCLES, value : data })}
                          value={context.cycles}>
                          { cycleValues.map(cycle => {
                              return <Checkbox key={cycle.cycleId} value={cycle.cycleName}>{cycle.cycleName}</Checkbox>
                          })}
                      </ControlGroup>
                      {VIEW_TO_FILTERS_MAP[props.view].includes("LOCAL_STATION_ARRIVAL_TIME") ?
                          <Column heights="fill" alignmentHorizontal="left">

                              <ControlGroup
                                  label={props.intl.formatMessage({id: FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.STATION_ARRIVAL_TIME})}
                                  onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.STATION_ARRIVAL_TIME, value : data })}
                                  value={context.stationArrivalTime}>
                                  <Checkbox key={today} value={today}>{today}</Checkbox>

                              </ControlGroup>

                          </Column> : null}
                  </Column> : null}

              {isCPTFilterEnabled && VIEW_TO_FILTERS_MAP[props.view].includes("CPT") ?
                  <Column heights="fill" spacingInset="none medium none">
                      <ControlGroup
                          label={props.intl.formatMessage({id: FORMATTED_MESSAGE_IDS.CPT_PREFIX + filtersData.CPTLabel})}
                          name={FILTER_KEYS.CPT}
                          onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.CPT, value : data })}
                          value={context.CPT}>
                          { CPTValues.map(CPT => {
                              return <Checkbox key={CPT.id} value={CPT.label}>{CPT.label}</Checkbox>
                          })}
                      </ControlGroup>
                      {VIEW_TO_FILTERS_MAP[props.view].includes("LOCAL_STATION_ARRIVAL_TIME") ?
                          <Column heights="fill" alignmentHorizontal="left">

                              <ControlGroup
                                  label={props.intl.formatMessage({id: FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.STATION_ARRIVAL_TIME})}
                                  onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.STATION_ARRIVAL_TIME, value : data })}
                                  value={context.stationArrivalTime}>
                                  <Checkbox key={today} value={today}>{today}</Checkbox>

                              </ControlGroup>

                          </Column> : null}
                  </Column> : null}

              {VIEW_TO_FILTERS_MAP[props.view].includes("EAD") ?
                  <Column heights="fill" spacingInset="none medium none"><Text type="h100"><FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.ESTIMATED_ARRIVAL_DATE} defaultMessage="Estimated Arrival Date"/></Text>
                      {isMobile ?
                          <Row>
                              {renderEstimatedArrivalDatePickers()}
                          </Row> : renderEstimatedArrivalDatePickers()}
                  </Column> : null}

              { VIEW_TO_FILTERS_MAP[props.view].includes("PACKAGE_TYPE") ?
                  <Column heights="fill" spacingInset="none medium none">
                      <ControlGroup
                          label={props.intl.formatMessage({id: FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.SHIPMENT_TYPE})}
                          onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.PACKAGE_TYPES, value : data })}
                          value={context.packageTypes}>
                          { filtersData.packageTypes.map(packageType => {
                              return <Checkbox key = {packageType } value={packageType}><FormattedMessage id={formattedIdPrefix.concat(packageType.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={packageType}/></Checkbox>
                          })}
                      </ControlGroup>
                  </Column> : null }

              { VIEW_TO_FILTERS_MAP[props.view].includes("PACKAGE_TYPE_REVERSE") ?
                  <Column heights="fill" spacingInset="none medium none">
                      <ControlGroup
                          label={props.intl.formatMessage({id: FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.SHIPMENT_TYPE})}
                          onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.PACKAGE_TYPES_REVERSE, value : data })}
                          value={context.packageTypes_Reverse}>
                          { filtersData.packageTypes_Reverse
                              .filter(packageType => packageType !== WASTE_TRANSFER_NOTE || isEWasteWtnEnabled)
                              .map(packageType => {
                              return <Checkbox key = {packageType } value={packageType}><FormattedMessage id={formattedIdPrefix.concat(packageType.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={packageType}/></Checkbox>
                          })}
                      </ControlGroup>
                  </Column> : null }

              { VIEW_TO_FILTERS_MAP[props.view].includes("PACKAGE_STATUS") ?
                  <Column heights="fill" spacingInset="none small none">
                      <Text type="h100"><FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.PACKAGE_STATUS} defaultMessage="Package Status"/></Text>
                      <Select value={context.packageStatuses.map(status => getDirectionInTier2(context.leg ,status))}
                              onChange={(data) => dispatch({ type: FILTER_ACTIONS.SELECT_FILTER, key : FILTER_KEYS.PACKAGE_STATUSES , value : data })}
                              placeholder={props.intl.formatMessage({id: FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.SELECT_PACKAGE_STATE})}
                              width={170}>
                          { packageStatusValues.map(packageStatus => {return (<SelectOption value={packageStatus} label={props.intl.formatMessage({id: FORMATTED_MESSAGE_IDS.COMMONS_PREFIX.concat(packageStatus.toLocaleLowerCase().split(' ').join('_'))})}/> )})}</Select>
                  </Column>

                  : null }


              { VIEW_TO_FILTERS_MAP[props.view].includes("DWELL_TIME") && context.page === "DWELL"?

                  <Column heights="fill" spacingInset="none small none"> <Text type="h100"><FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.MINUTES_IN_STATE} defaultMessage="Minutes in State"/></Text>
                      {isMobile ?
                          <Row>
                              {renderMinutesInStateInputs()}
                          </Row> : renderMinutesInStateInputs()
                      }
                  </Column> : null
              }

              {VIEW_TO_FILTERS_MAP[props.view].includes("AGEING_TIME") && context.page === "AGEING"?

                  <Column heights="fill" spacingInset="none small none"> <Text type="h100"><FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.LAST_UPDATED_DATE} defaultMessage="Last Updated Date"/></Text>

                      {isMobile ? <Row>
                          {renderLastUpdatedDatePickers()}
                      </Row> : renderLastUpdatedDatePickers()}
                  </Column>   : null
              }
              {(isINRegion() && VIEW_TO_FILTERS_MAP[props.view].includes("SHIP_DATE")) ?
                  <Column heights="fill" spacingInset="none medium none"><Text type="h100"><FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.SHIP_DATE} defaultMessage="Ship Date"/></Text>
                      {isMobile ?
                      <Row>
                          {renderShipDatePickers()}
                      </Row> : renderShipDatePickers()}
                  </Column> : null}
              </Fragment>
          );
      }

      function renderFilterSearchButton() {
          return (
              <Fragment>
                  {VIEW_TO_FILTERS_MAP[props.view].includes("APPLY_FILTER") ?
                          <Button type="tertiary" onClick={() => {
                              dispatch({ type: FILTER_ACTIONS.APPLY_FILTER,  key : "" , value : "" });
                              enableToaster();
                          }}>
                              <FormattedMessage id={FORMATTED_MESSAGE_IDS.FILTERS_PREFIX + FORMATTED_MESSAGE_IDS.SEARCH} defaultMessage="Search"/></Button>


                          : null}
              </Fragment>
          )
      }

      return (
          <Column spacing={"none"}>
              {isCPTFilterEnabled? getCPTData(): getCycleData()}
              <React.Fragment>
                  <Toaster toasts={toasters} onCloseToast={() => setToasters([])} alignmentHorizontal="center">
                      {(toast) => <Alert toast={true}>{toast.id}</Alert>}
                  </Toaster>
                  <Box>
                          {isMobile ?
                              <FilterExpander onToggle={setIsFilterExpanded}>
                                  <Column alignmentHorizontal={"stretch"} alignmentVertical={"center"} spacingInset={spacingInset_shorthand4} backgroundColor="secondary">
                                      {renderFilterOptions()}
                                      {renderFilterSearchButton()}
                                  </Column>
                              </FilterExpander>
                              :
                              <Row alignmentVertical="top" alignment="top left" spacingInset={spacingInset_shorthand4} backgroundColor="secondary">
                                  {renderFilterOptions()}
                              </Row>
                          }
                  </Box>
                  <Row widths={isMobile ? ["grid-0", "grid-12"] : ["grid-11", "grid-1"]} >
                      <Box>
                          <Row widths={[]}>
                              {(isMobile && isFilterExpanded) || !isMobile ? renderAppliedFilterTags() : null}
                          </Row>
                      </Box>
                      <MobileDisplay visibility={false}>
                          <Column alignmentHorizontal={isMobile ? "center" : "right"}>
                              {renderFilterSearchButton()}
                          </Column>
                    </MobileDisplay>
                  </Row>
              </React.Fragment>
          </Column>
      )
  }


  const constructState = (selectedFilterValues, context) => {

      if (selectedFilterValues.enableDwellFilter === false) {
          selectedFilterValues.lastUpdatedStart = "";
          selectedFilterValues.lastUpdatedEnd = "";
          selectedFilterValues.enableDwellFilter = true;
      }

      var values = {

          sameDay : selectedFilterValues.sameDay,
          startPDD : selectedFilterValues.startPDD,
          endPDD : selectedFilterValues.endPDD,
          packageTypes : selectedFilterValues.packageTypes,
          cycles : selectedFilterValues.cycles,
          CPT: selectedFilterValues.CPT,
          packageStatuses : selectedFilterValues.packageStatuses.map(status => status.replace('/','%2f')),
          dwellEndTime: context.dwellEnd,
          dwellStartTime : context.dwellStart,
          stationArrivalTime : selectedFilterValues.stationArrivalTime,
          dwellEndTimeUnit : context.dwellEndTimeUnit,
          dwellStartTimeUnit : context.dwellStartTimeUnit,
          shipDateStart : selectedFilterValues.shipDateStart,
          shipDateEnd : selectedFilterValues.shipDateEnd,
          deliveryWindow : selectedFilterValues.deliveryWindow,
          enableDwellFilter: selectedFilterValues.enableDwellFilter ? selectedFilterValues.enableDwellFilter : true
      }

      //Redirect to search path
      var path = window.location.href.split(MISC_CONSTANTS.PACKAGE_SEARCH_PATH)[0];
      window.location.replace( path + MISC_CONSTANTS.PACKAGE_SEARCH_PATH + "/"+ JSON.stringify(values).replace('/','%2f'));
  }

  export default injectIntl(CommonFilters);


// WEBPACK FOOTER //
// ./src/commons/CommonFilters.js